import React, { useState, useContext } from 'react';
import {
  makeStyles,
  Grid,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from '@material-ui/core';
import InputMask from 'react-input-mask';
import _ from 'lodash';

import zipApi from 'app/api/services/zipCodeEndpoints';
import { Field } from 'formik';
import generalEndpoints from 'app/api/services/generalEndpoints';
import { useSelector, useDispatch } from 'react-redux';
import { setCity } from 'app/store/slices/forms';
import { FormServiceContext } from 'app/utils/contexts';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { SERVICES_CODES } from 'app/config/services';

import styles from './styles';
const useStyles = makeStyles(styles);

function Address(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { errors, values } = props;

  const { canEdit } = useContext(FormServiceContext);
  const cepMask = '99999-999';

  const [loadingHeadquartersAddress, setLoadingAddress] = useState(false);
  const [cities, setCities] = useState([]);

  const city = useSelector(state => state.forms.city);
  const service = useSelector(state => state.services.details);

  const searchAddress = async e => {
    let cep = e.target.value;
    setLoadingAddress(true);
    if (cep && cep !== '') {
      cep = cep.replace(/[^0-9]+/g, '');
      if (cep.length === 8) {
        const result = await zipApi.zipCodeSearch(cep);
        if (result) {
          if (result.erro) {
            result.cep = cep;
            result.uf = '';
            result.localidade = '';
            result.bairro = '';
            result.logradouro = '';
            await dispatch(setCity({}));
          }
          if (!values.enderecoPessoa) values.enderecoPessoa = {};
          values.enderecoPessoa.deCep = result.cep;
          values.enderecoPessoa.uf = result.uf;
          values.enderecoPessoa.municipio = result.localidade;
          values.enderecoPessoa.deBairro = result.bairro;
          values.enderecoPessoa.deEndereco = result.logradouro;
          if (!result.erro) {
            const response = await searchCity(result.uf, 'enderecoPessoa.uf');
            const cityFound = _.find(response, ['nmMunicipio', result.localidade]);
            if (cityFound) {
              await onChangeCity(null, cityFound);
            }
          }
        }
      }
    }
    setLoadingAddress(false);
  };

  const searchCity = async uf => {
    setLoadingAddress(true);
    if (uf && uf !== '') {
      const response = await generalEndpoints.getCities(uf);
      if (setCities) setCities(response.data);
      setLoadingAddress(false);
      return response.data;
    }
    setLoadingAddress(false);
  };

  const onChangeCity = (e, v) => {
    const value = v ? v : e.target.value;
    if (value) {
      const temp = { ...city };
      temp.cityPrincipal = { ...value };
      if (!temp.cityPrincipal.nmMunicipio) temp.cityPrincipal.nmMunicipio = value;
      dispatch(setCity(temp));
      values.enderecoPessoa.municipio = value;
      values.enderecoPessoa.cdMunicipio = value.cdMunicipio;
    } else {
      const temp = _.cloneDeep(city);
      if (temp.cityPrincipal) delete temp.cityPrincipal;
      dispatch(setCity(temp));
      values.enderecoPessoa.municipio = {};
      values.enderecoPessoa.cdMunicipio = null;
    }
  };

  return (
    <>
      <Grid container spacing={3} className={classes.containerAddessTitle}>
        <Grid item xs={12}>
          <h3 className={classes.addressTitle}>Endereço</h3>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={2} className={classes.positionRelative}>
          {canEdit && service.cdServico !== SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ? (
            <Field name="enderecoPessoa.deCep">
              {({ field, form: { errors, values } }) => (
                <InputMask
                  mask={cepMask}
                  {...field}
                  value={values.enderecoPessoa?.deCep ? values.enderecoPessoa.deCep : ''}
                  onBlur={e => searchAddress(e)}
                >
                  {props => (
                    <TextField
                      {...props}
                      name="enderecoPessoa.deCep"
                      label="CEP*"
                      variant="filled"
                      margin="dense"
                      fullWidth
                      error={!!errors.enderecoPessoa?.deCep}
                      helperText={errors.enderecoPessoa?.deCep ? errors.enderecoPessoa.deCep : ''}
                      inputProps={{
                        form: {
                          autocomplete: 'off',
                        },
                      }}
                    />
                  )}
                </InputMask>
              )}
            </Field>
          ) : (
            <TextField
              value={values.enderecoPessoa?.deCep ? values.enderecoPessoa.deCep : ''}
              label="CEP*"
              variant="filled"
              margin="dense"
              disabled
              fullWidth
            />
          )}
          {loadingHeadquartersAddress && (
            <CircularProgress
              className={classes.circularProgress}
              disableShrink={true}
              size={18}
              thickness={6}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoPessoa?.uf}
          >
            <InputLabel
              htmlFor="uf"
              shrink={values.enderecoPessoa?.uf || city?.cityPrincipal?.uf?.sgUf ? true : false}
            >
              UF*
            </InputLabel>
            <Field
              name="enderecoPessoa.uf"
              id="enderecoPessoa.uf"
              native
              as={Select}
              value={
                values.enderecoPessoa?.uf
                  ? values.enderecoPessoa?.uf
                  : city?.cityPrincipal?.uf?.sgUf
                  ? city.cityPrincipal.uf.sgUf
                  : ''
              }
              onBlur={e => searchCity(e.target.value)}
            >
              <option value=""></option>
              <option value="AC">AC</option>
              <option value="AL">AL</option>
              <option value="AM">AM</option>
              <option value="AP">AP</option>
              <option value="BA">BA</option>
              <option value="CE">CE</option>
              <option value="DF">DF</option>
              <option value="ES">ES</option>
              <option value="GO">GO</option>
              <option value="MA">MA</option>
              <option value="MG">MG</option>
              <option value="MS">MS</option>
              <option value="MT">MT</option>
              <option value="PA">PA</option>
              <option value="PB">PB</option>
              <option value="PE">PE</option>
              <option value="PI">PI</option>
              <option value="PR">PR</option>
              <option value="RJ">RJ</option>
              <option value="RN">RN</option>
              <option value="RO">RO</option>
              <option value="RR">RR</option>
              <option value="RS">RS</option>
              <option value="SC">SC</option>
              <option value="SE">SE</option>
              <option value="SP">SP</option>
              <option value="TO">TO</option>
            </Field>
            {errors.enderecoPessoa?.uf ? (
              <FormHelperText>{errors.enderecoPessoa.uf}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field name="enderecoPessoa.municipio">
            {({ field, form: { errors } }) => {
              return (
                <div className={classes.positionRelative}>
                  <Autocomplete
                    options={cities}
                    getOptionLabel={option => (option['nmMunicipio'] ? option['nmMunicipio'] : '')}
                    value={city?.cityPrincipal ? city.cityPrincipal : {}}
                    onChange={onChangeCity}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Município*"
                        fullWidth
                        variant="filled"
                        margin="dense"
                        disabled={
                          !canEdit ||
                          service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
                        }
                        error={!!errors.enderecoPessoa?.municipio}
                        helperText={
                          errors.enderecoPessoa?.municipio?.cdMunicipio
                            ? errors.enderecoPessoa.municipio.cdMunicipio
                            : ''
                        }
                      />
                    )}
                  />
                  {loadingHeadquartersAddress && (
                    <CircularProgress
                      className={classes.circularProgress}
                      disableShrink={true}
                      size={18}
                      thickness={6}
                    />
                  )}
                </div>
              );
            }}
          </Field>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            name="enderecoPessoa.deBairro"
            label="Bairro*"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoPessoa?.deBairro}
            helperText={errors.enderecoPessoa?.deBairro ? errors.enderecoPessoa.deBairro : ''}
            value={values.enderecoPessoa?.deBairro ? values.enderecoPessoa.deBairro : ''}
            as={TextField}
            inputProps={{
              maxLength: 50,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            name="enderecoPessoa.deEndereco"
            label="Endereço*"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoPessoa?.deEndereco}
            helperText={errors.enderecoPessoa?.deEndereco ? errors.enderecoPessoa.deEndereco : ''}
            value={values.enderecoPessoa?.deEndereco ? values.enderecoPessoa.deEndereco : ''}
            as={TextField}
            inputProps={{
              maxLength: 100,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Field
            name="enderecoPessoa.deNumeroEndereco"
            label="Número"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            error={!!errors.enderecoPessoa?.deNumeroEndereco}
            helperText={
              errors.enderecoPessoa?.deNumeroEndereco ? errors.enderecoPessoa.deNumeroEndereco : ''
            }
            value={
              values.enderecoPessoa?.deNumeroEndereco ? values.enderecoPessoa.deNumeroEndereco : ''
            }
            as={TextField}
            inputProps={{
              maxLength: 7,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Field
            name="enderecoPessoa.deComplemento"
            label="Complemento"
            variant="filled"
            margin="dense"
            disabled={
              !canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC
            }
            fullWidth
            value={values.enderecoPessoa?.deComplemento ? values.enderecoPessoa.deComplemento : ''}
            as={TextField}
            inputProps={{
              maxLength: 50,
              form: {
                autocomplete: 'off',
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Address;
